import jwt_decode from 'jwt-decode';
export default function () {
    let token = jwt_decode(localStorage.getItem('access_token'));
    return token?.anonimo;
}